import { setAuthToken, clearAuthToken } from "../auth";
import { getUrlOrgId } from "../url";

function forceLogout(accountsUrl: string) {
  clearAuthToken();
  window.location.href =
    accountsUrl + "/_/login" + `?continueUrl=${window.location.href}`;
}

function handleResponseError(error: string, accountsUrl: string) {
  if (error === "userMustBeLoggedIn" || error === "authenticationFailure") {
    forceLogout(accountsUrl);
  }

  if (error === "policyNotAccepted") {
    window.location.href =
      accountsUrl + "/_/accept-policy" + `?continueUrl=${window.location.href}`;
  }

  if (error === "unconfirmedEmail") {
    window.location.href =
      accountsUrl +
      "/_/unconfirmed-email" +
      `?continueUrl=${window.location.href}`;
  }

  if (error === "organizationTermsNotAccepted") {
    window.location.href =
      accountsUrl + "/" +
      getUrlOrgId() +
      "/accept-terms" +
      `?continueUrl=${window.location.href}`;
  }
}

function subscribeToPorts(app: any, accountsUrl: string) {
  if (app.ports.sendForceLogout) {
    app.ports.sendForceLogout.subscribe(() => {
      forceLogout(accountsUrl);
    });
  }

  if (app.ports.sendRequestLogout) {
    app.ports.sendRequestLogout.subscribe(() => {
      clearAuthToken();
      window.location.href = accountsUrl + "/_/login";
    });
  }

  if (app.ports.sendLogIn) {
    app.ports.sendLogIn.subscribe((authToken: string) => {
      setAuthToken(authToken);
    });
  }

  if (app.ports.sendResponseError) {
    app.ports.sendResponseError.subscribe((error: string) => {
      handleResponseError(error, accountsUrl);
    });
  }
}

export default { handleResponseError, subscribeToPorts };
